module.exports = __webpack_public_path__ + "img/payment-icon.663867c0.svg";